export const CACHE_ENABLED = true;

export const FETCH_SETTINGS: any = {
  // cache: CACHE_ENABLED ? "default" : "no-cache",
  headers: {
    "Accept-Language": "tr",
    // "Content-Type": "application/json",
  },
};

export const MANAGER_URL = process.env.NEXT_PUBLIC_MANAGER_APP_URL;
export const LOCALIZATION_URL = process.env.NEXT_PUBLIC_LOCALIZATION_URL

export const DEFAULT_IMAGES = {
  WORKER: "default_user.jpg",
  VENUE_LOGO: "default_venue.jpg",
  COMPANY_LOGO_LARGE: "default_venue.jpg"
};

export const CONTACT_PHONE_NUMBER = process.env.NEXT_PUBLIC_CONTACT_PHONE;

export const URLS_PER_SITEMAP = 1000 * 5;

export const STATIC_ROUTES = [
  "/",
  "/sirket-indirimleri",
  "/ekle",
  "/kampanyalar",
  "/etkinlikler",
  "/blog",
  "/ucretsiz-teklif-al",
  "/hakkimizda",
  "/kullanim-kosullari",
  "/yasal-uyari",
  // "/yardim",
  "/site-haritasi",
  "/iletisim",
];
